/* Byteful Studio 2.0 · temel etkileşimler */
(function () {
  'use strict';

  var root = document.documentElement;
  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function motionOK() {
    return !reducedQuery.matches && !root.classList.contains('bd-motion-off');
  }

  function rafThrottle(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        fn();
      });
    };
  }

  /* ---------------------------------------------------------------
     Kaydırınca beliren öğeler
     --------------------------------------------------------------- */
  if (window.__bdRevealTimer) window.clearTimeout(window.__bdRevealTimer);

  var revealObserver = null;
  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  } else {
    root.classList.add('bd-reveal-all');
  }

  function observeReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!revealObserver) return;
    items.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------------------------------------------------------------
     Üst menü
     --------------------------------------------------------------- */
  class BdHeader extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.lastY = window.scrollY;
      this.announce = document.querySelector('[data-bd-announce]');
      this.mobileQuery = window.matchMedia('(max-width: 760px)');
      this.handleScroll = rafThrottle(this.onScroll.bind(this));
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });
      this.onScroll();
      this.setupDropdowns();
      this.setupMenu();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }

    onScroll() {
      var y = window.scrollY;
      var base = this.mobileQuery.matches ? 10 : 14;
      var top = base;
      if (this.announce && this.announce.offsetHeight) {
        top = Math.max(base, this.announce.offsetHeight + base - y);
      }
      this.style.setProperty('--bd-header-top', top + 'px');
      this.classList.toggle('is-scrolled', y > 24);

      var delta = y - this.lastY;
      var menuOpen = this.querySelector('.bd-nav__item--menu.is-open');
      if (y > 360 && delta > 6 && !menuOpen) {
        this.classList.add('is-hidden');
      } else if (delta < -6 || y < 360) {
        this.classList.remove('is-hidden');
      }
      this.lastY = y;
    }

    setupDropdowns() {
      var hoverCapable = window.matchMedia('(hover: hover)').matches;
      this.querySelectorAll('[data-bd-dropdown]').forEach(function (item) {
        var trigger = item.querySelector('[data-bd-dropdown-trigger]');
        var panel = item.querySelector('[data-bd-dropdown-panel]');
        var timer = null;
        if (!trigger || !panel) return;

        function open() {
          window.clearTimeout(timer);
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        function close() {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }

        item.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse') open();
        });
        item.addEventListener('pointerleave', function (event) {
          if (event.pointerType === 'mouse') timer = window.setTimeout(close, 160);
        });
        trigger.addEventListener('click', function (event) {
          if (!hoverCapable && !item.classList.contains('is-open')) {
            event.preventDefault();
            open();
          }
        });
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            open();
            var first = panel.querySelector('a');
            if (first) first.focus();
          }
        });
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', function (event) {
          if (!item.contains(event.relatedTarget)) close();
        });
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && item.classList.contains('is-open')) {
            close();
            trigger.focus();
          }
        });
        document.addEventListener('pointerdown', function (event) {
          if (!item.contains(event.target)) close();
        });
      });
    }

    setupMenu() {
      var dialog = this.querySelector('[data-bd-menu]');
      var openButton = this.querySelector('[data-bd-menu-open]');
      if (!dialog || !openButton) return;
      var closeButton = dialog.querySelector('[data-bd-menu-close]');

      openButton.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.body.classList.add('bd-locked');
        openButton.setAttribute('aria-expanded', 'true');
      });

      function closeMenu() {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          dialog.dispatchEvent(new Event('close'));
        }
      }

      dialog.addEventListener('close', function () {
        document.body.classList.remove('bd-locked');
        openButton.setAttribute('aria-expanded', 'false');
      });
      if (closeButton) closeButton.addEventListener('click', closeMenu);
      dialog.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeMenu();
      });
      window.matchMedia('(min-width: 1081px)').addEventListener('change', function (event) {
        if (event.matches) closeMenu();
      });
    }
  }

  /* ---------------------------------------------------------------
     Byte alanı: hareketli kare ızgarası
     --------------------------------------------------------------- */
  var LIME = [208, 242, 75];

  class BdByteField extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.canvas = this.querySelector('canvas');
      if (!this.canvas || !this.canvas.getContext) return;
      this.ctx = this.canvas.getContext('2d', { alpha: false });
      this.showMark = this.dataset.mark !== 'false';
      this.text = this.dataset.text || '';
      this.pointer = { x: -9999, y: -9999, sx: -9999, sy: -9999 };
      this.ripples = [];
      this.visible = true;
      this.start = performance.now();
      this.accent = this.readAccent();
      this.buckets = [];

      this.resizeObserver = new ResizeObserver(rafThrottle(this.build.bind(this)));
      this.resizeObserver.observe(this);

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(function (entries) {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.play();
        }.bind(this));
        this.visibilityObserver.observe(this);
      }

      var host = this.parentElement || this;
      this.onMove = function (event) {
        var rect = this.getBoundingClientRect();
        this.pointer.x = event.clientX - rect.left;
        this.pointer.y = event.clientY - rect.top;
      }.bind(this);
      this.onLeave = function () {
        this.pointer.x = -9999;
        this.pointer.y = -9999;
      }.bind(this);
      this.onDown = function (event) {
        var rect = this.getBoundingClientRect();
        this.ripples.push({ x: event.clientX - rect.left, y: event.clientY - rect.top, t: performance.now() });
        if (this.ripples.length > 4) this.ripples.shift();
      }.bind(this);
      host.addEventListener('pointermove', this.onMove, { passive: true });
      host.addEventListener('pointerleave', this.onLeave, { passive: true });
      host.addEventListener('pointerdown', this.onDown, { passive: true });
      this.host = host;

      this.onVisibility = function () {
        if (!document.hidden) this.play();
      }.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.build();
      if (document.fonts && this.text) {
        document.fonts.ready.then(this.build.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
      if (this.host) {
        this.host.removeEventListener('pointermove', this.onMove);
        this.host.removeEventListener('pointerleave', this.onLeave);
        this.host.removeEventListener('pointerdown', this.onDown);
      }
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.cancelAnimationFrame(this.frameId);
      this._ready = false;
    }

    readAccent() {
      var value = getComputedStyle(document.documentElement).getPropertyValue('--accent').trim();
      var match = /^#([0-9a-f]{6})$/i.exec(value);
      if (!match) return LIME;
      var n = parseInt(match[1], 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }

    build() {
      var w = this.clientWidth;
      var h = this.clientHeight;
      if (!w || !h) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.w = w;
      this.h = h;
      this.dpr = dpr;
      this.canvas.width = Math.round(w * dpr);
      this.canvas.height = Math.round(h * dpr);
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var mobile = w < 760;
      this.mobile = mobile;
      var step = mobile ? 19 : 17;
      this.step = step;
      var cols = Math.ceil(w / step) + 1;
      var rows = Math.ceil(h / step) + 1;

      /* İşaretin yeri ve boyu */
      var size;
      var cx;
      var cy;
      if (mobile) {
        size = Math.min(w * 0.42, 190);
        cx = w - size * 0.62;
        cy = Math.max(110, h * 0.16) + size * 0.3;
      } else {
        size = Math.min(h * 0.5, w * 0.3, 470);
        cx = w * 0.75;
        cy = h * 0.43;
      }
      var block = size * 0.28;
      var gap = (size - block * 3) / 2;
      var left = cx - size / 2;
      var top = cy - size / 2;

      /* 404 gibi metin maskesi */
      var textMask = null;
      if (this.text) {
        var off = document.createElement('canvas');
        off.width = Math.ceil(w);
        off.height = Math.ceil(h);
        var octx = off.getContext('2d');
        var fontSize = mobile ? w * 0.4 : Math.min(h * 0.55, w * 0.3);
        octx.fillStyle = '#fff';
        octx.textAlign = 'center';
        octx.textBaseline = 'middle';
        octx.font = '600 ' + fontSize + "px 'Byteful Display', 'Inter Tight', sans-serif";
        octx.fillText(this.text, mobile ? w * 0.5 : w * 0.68, mobile ? h * 0.2 : h * 0.5);
        textMask = octx.getImageData(0, 0, off.width, off.height).data;
        this.maskWidth = off.width;
      }

      var cells = [];
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var x = c * step + step / 2;
          var y = r * step + step / 2;
          var mark = 0;
          if (this.showMark && !this.text) {
            var lx = x - left;
            var ly = y - top;
            if (lx >= 0 && ly >= 0 && lx <= size && ly <= size) {
              var bx = Math.floor(lx / (block + gap));
              var by = Math.floor(ly / (block + gap));
              var inX = lx - bx * (block + gap) <= block;
              var inY = ly - by * (block + gap) <= block;
              if (inX && inY && bx < 3 && by < 3 && !(bx === 1 && by === 1)) mark = 1;
            }
          }
          if (textMask) {
            var px = Math.min(this.maskWidth - 1, Math.max(0, Math.round(x)));
            var py = Math.min(h - 1, Math.max(0, Math.round(y)));
            if (textMask[(py * this.maskWidth + px) * 4 + 3] > 128) mark = 1;
          }
          cells.push({
            x: x,
            y: y,
            mark: mark,
            phase: Math.random() * Math.PI * 2,
            delay: mark ? 250 + Math.random() * 1300 : 0,
            fade: this.fadeFor(x, y, w, h, mobile)
          });
        }
      }
      this.cells = cells;
      this.markAlpha = mobile ? 0.62 : 1;
      if (!motionOK()) {
        this.draw(this.start + 5000, true);
      } else {
        this.play();
      }
    }

    fadeFor(x, y, w, h, mobile) {
      if (mobile) {
        var fy = 1 - Math.min(1, y / (h * 0.9));
        return 0.28 + 0.4 * fy;
      }
      var t = (x - w * 0.16) / (w * 0.5);
      t = Math.max(0, Math.min(1, t));
      t = t * t * (3 - 2 * t);
      var bottom = y > h * 0.82 ? 1 - (y - h * 0.82) / (h * 0.18) * 0.6 : 1;
      return (0.16 + 0.84 * t) * bottom;
    }

    play() {
      if (this.frameId || !motionOK() || !this.visible || document.hidden) return;
      var loop = function (now) {
        this.frameId = 0;
        if (!this.visible || document.hidden || !this.isConnected) return;
        this.draw(now, false);
        this.frameId = window.requestAnimationFrame(loop);
      }.bind(this);
      this.frameId = window.requestAnimationFrame(loop);
    }

    draw(now, still) {
      var ctx = this.ctx;
      var cells = this.cells;
      if (!ctx || !cells) return;
      var t = now - this.start;
      var p = this.pointer;
      if (p.x < -1000) {
        p.sx = -9999;
        p.sy = -9999;
      } else if (p.sx < -1000) {
        p.sx = p.x;
        p.sy = p.y;
      } else {
        p.sx += (p.x - p.sx) * 0.18;
        p.sy += (p.y - p.sy) * 0.18;
      }
      var ripples = this.ripples.filter(function (rp) { return now - rp.t < 2400; });
      this.ripples = ripples;

      ctx.fillStyle = '#0a0a0a';
      ctx.fillRect(0, 0, this.w, this.h);

      var levels = 28;
      var buckets = this.buckets;
      for (var b = 0; b < levels * 2; b++) {
        if (!buckets[b]) buckets[b] = [];
        buckets[b].length = 0;
      }

      var accent = this.accent;
      var radius = this.mobile ? 110 : 150;
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        var wave = Math.sin(cell.x * 0.011 + t * 0.00055) * Math.cos(cell.y * 0.016 - t * 0.0004);
        var base = (0.1 + 0.2 * (wave * 0.5 + 0.5) * (wave * 0.5 + 0.5)) * cell.fade;

        var near = 0;
        if (p.sx > -1000) {
          var dx = cell.x - p.sx;
          var dy = cell.y - p.sy;
          var d = Math.sqrt(dx * dx + dy * dy);
          if (d < radius) {
            near = 1 - d / radius;
            near *= near;
          }
        }
        var ring = 0;
        for (var k = 0; k < ripples.length; k++) {
          var rp = ripples[k];
          var age = now - rp.t;
          var rr = age * 0.5;
          var rdx = cell.x - rp.x;
          var rdy = cell.y - rp.y;
          var dist = Math.sqrt(rdx * rdx + rdy * rdy);
          var diff = dist - rr;
          if (diff > -40 && diff < 40) ring += Math.exp(-(diff * diff) / 360) * (1 - age / 2400);
        }

        var markLevel = 0;
        if (cell.mark) {
          var boot = still ? 1 : Math.max(0, Math.min(1, (t - cell.delay) / 500));
          var breathe = 0.78 + 0.22 * Math.sin(t * 0.0018 + cell.phase);
          markLevel = boot * (still ? 0.95 : breathe) * this.markAlpha;
        }

        var size = 2 + near * 3 + ring * 2.2 + markLevel * 2.4;
        var hot = Math.max(markLevel, Math.min(1, near * 0.9 + ring * 0.7));
        var level;
        var bucket;
        if (hot > 0.04) {
          level = Math.min(levels - 1, Math.round(hot * (levels - 1)));
          bucket = levels + level;
        } else {
          level = Math.min(levels - 1, Math.round(base * 2.2 * (levels - 1)));
          bucket = level;
        }
        buckets[bucket].push(cell.x - size / 2, cell.y - size / 2, size);
      }

      for (var j = 0; j < levels * 2; j++) {
        var list = buckets[j];
        if (!list.length) continue;
        if (j < levels) {
          var g = Math.round(10 + (j / (levels - 1)) * 120);
          ctx.fillStyle = 'rgb(' + g + ',' + g + ',' + Math.max(0, g - 3) + ')';
        } else {
          var a = (j - levels) / (levels - 1);
          var rC = Math.round(40 + (accent[0] - 40) * a);
          var gC = Math.round(40 + (accent[1] - 40) * a);
          var bC = Math.round(38 + (accent[2] - 38) * a);
          ctx.fillStyle = 'rgb(' + rC + ',' + gC + ',' + bC + ')';
        }
        ctx.beginPath();
        for (var q = 0; q < list.length; q += 3) {
          ctx.rect(list[q], list[q + 1], list[q + 2], list[q + 2]);
        }
        ctx.fill();
      }
    }
  }

  /* ---------------------------------------------------------------
     Büyüme döngüsü
     --------------------------------------------------------------- */
  class BdGrowthLoop extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('.bd-loop__btn'));
      this.center = this.querySelector('.bd-loop__center');
      this.titleEl = this.querySelector('[data-loop-title]');
      this.textEl = this.querySelector('[data-loop-text]');
      this.index = 0;
      this.paused = false;
      this.userPicked = false;
      this.visible = false;

      this.buttons.forEach(function (button, i) {
        button.addEventListener('click', function () {
          this.userPicked = true;
          this.select(i);
        }.bind(this));
      }.bind(this));

      this.addEventListener('pointerenter', function () { this.paused = true; }.bind(this));
      this.addEventListener('pointerleave', function () { this.paused = false; }.bind(this));
      this.addEventListener('focusin', function () { this.paused = true; }.bind(this));
      this.addEventListener('focusout', function () { this.paused = false; }.bind(this));

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          this.visible = entries[0].isIntersecting;
        }.bind(this), { threshold: 0.3 });
        this.io.observe(this);
      }

      if (motionOK() && this.buttons.length > 1) {
        this.timer = window.setInterval(function () {
          if (this.paused || this.userPicked || !this.visible || document.hidden) return;
          this.select((this.index + 1) % this.buttons.length);
        }.bind(this), 3400);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      if (this.io) this.io.disconnect();
      this._ready = false;
    }

    select(i) {
      var button = this.buttons[i];
      if (!button) return;
      this.index = i;
      this.buttons.forEach(function (b, n) { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      if (this.titleEl) this.titleEl.textContent = button.dataset.title || '';
      if (this.textEl) this.textEl.textContent = button.dataset.text || '';
      if (this.center && motionOK()) {
        this.center.classList.remove('is-changing');
        void this.center.offsetWidth;
        this.center.classList.add('is-changing');
      }
    }
  }

  /* ---------------------------------------------------------------
     Sayaç
     --------------------------------------------------------------- */
  class BdCount extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var raw = (this.dataset.value || this.textContent || '').trim();
      var match = /^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/.exec(raw);
      if (!match || !motionOK() || !('IntersectionObserver' in window)) return;
      var prefix = match[1];
      var suffix = match[3];
      var numberText = match[2];
      var decimals = /[.,](\d+)/.exec(numberText);
      var places = decimals ? decimals[1].length : 0;
      var target = parseFloat(numberText.replace(',', '.'));
      var format = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: places, maximumFractionDigits: places });
      var el = this;
      el.textContent = prefix + format.format(0) + suffix;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var start = performance.now();
        var duration = 1400;
        function tick(now) {
          var progress = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - progress, 4);
          el.textContent = prefix + format.format(target * eased) + suffix;
          if (progress < 1) window.requestAnimationFrame(tick);
        }
        window.requestAnimationFrame(tick);
      }, { threshold: 0.4 });
      io.observe(el);
    }
  }

  /* ---------------------------------------------------------------
     Türkiye saati
     --------------------------------------------------------------- */
  class BdClock extends HTMLElement {
    connectedCallback() {
      var zone = this.dataset.tz || 'Europe/Istanbul';
      var format;
      try {
        format = new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit', timeZone: zone });
      } catch (error) {
        return;
      }
      var el = this;
      function tick() {
        el.textContent = 'Türkiye saati ' + format.format(new Date()) + ' · GMT+3';
      }
      tick();
      this.timer = window.setInterval(tick, 30000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }
  }

  /* ---------------------------------------------------------------
     Mobil alt çubuk
     --------------------------------------------------------------- */
  class BdMobileBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.hidden = false;
      this.update = rafThrottle(function () {
        var y = window.scrollY;
        var show = y > window.innerHeight * 0.55;
        var footer = document.querySelector('.bd-footer');
        var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
        this.classList.toggle('is-visible', show && !nearFooter);
      }.bind(this));
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }
  }

  function define(name, ctor) {
    if (!window.customElements.get(name)) window.customElements.define(name, ctor);
  }

  define('bd-header', BdHeader);
  define('bd-byte-field', BdByteField);
  define('bd-growth-loop', BdGrowthLoop);
  define('bd-count', BdCount);
  define('bd-clock', BdClock);
  define('bd-mobile-bar', BdMobileBar);

  function init() {
    observeReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Tema düzenleyicisi */
  document.addEventListener('shopify:section:load', function (event) {
    observeReveal(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var node = event.target.closest('.bd-loop__node');
    if (node) {
      var loop = node.closest('bd-growth-loop');
      var button = node.querySelector('.bd-loop__btn');
      if (loop && button) {
        loop.userPicked = true;
        loop.select(loop.buttons.indexOf(button));
      }
    }
  });
})();
